import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { Input } from '@1trading/react/components/ui/input';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { InstitutionBusinessProfileOrDefaults } from '@/features/institution/business-profile/schema';
import { InstitutionBusinessProfileFieldsetBreakdown } from './breakdown';

const InstitutionBusinessProfileFieldsetClients = () => {
  const form = useFormContext<InstitutionBusinessProfileOrDefaults>();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="totalClients"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.businessProfile.clients.totalClients')}*</FormLabel>
            <FormControl>
              <Input
                {...field}
                className="no-spinner"
                inputMode="numeric"
                placeholder={t('institutionDetails.businessProfile.placeholders.totalClients')}
                type="number"
                value={field.value ?? ''}
                onChange={(event) => field.onChange(event.target.value === '' ? undefined : Number(event.target.value))}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <InstitutionBusinessProfileFieldsetBreakdown name="clientTypeBreakdown" />
    </div>
  );
};
InstitutionBusinessProfileFieldsetClients.displayName = 'InstitutionBusinessProfileFieldsetClients';

export { InstitutionBusinessProfileFieldsetClients };
